import React from 'react';

import ErrorData from '../../../../../assets/images/service-error.png';
import { IErrorCard } from '../../../../interfaces/cards';
import BdsButton from '../../Buttons/BdsButton/BdsButton';

import './ErrorCard.scss';

const ErrorCard = ({ className, primaryText, secondaryText, buttonText, center = false, action }: IErrorCard) => {
  return (
    <div className={`error-card-content ${className} `}>
      <img src={ErrorData} className="error-data" alt="Error data" />
      <div className={`error-card-texts ${center && 'center'}`}>
        <div className="primary-text">{primaryText}</div>
        {secondaryText && <div className="secondary-text">{secondaryText}</div>}
      </div>
      {buttonText && action && (
        <BdsButton size="m" action={action} variant="secondary">
          {buttonText}
        </BdsButton>
      )}
    </div>
  );
};

export default ErrorCard;
